import { i18nString } from "./i18n";

const i18nStringWrapper = (str: i18nString["stringType"]) => {
  return str;
};

export default i18nStringWrapper;
